import React from "react";
import { SortableHandle } from "react-sortable-hoc";

// This can be any component you want
export default SortableHandle(() => (
	<div className="drag-handler" title="Sort">
		<div className="icon icon-select-arrows" />
	</div>
));



// WEBPACK FOOTER //
// ./src/components/utils/sortable/DragHandle.js